import React, { Component } from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import * as Actions from "../../../../store/modules/resources";

import TopNav from "../../../admin/etc/tab";
import {getParams, pushUrl} from "../../../../utils/functions";

import * as func from "../../../../utils/functions";

import DefaultForm from "./0_defaultForm";
import AuthorForm from "./1_authorForm";
import ExtendForm from "./2_extendForm";
import MetaForm from "./4_metaForm";
import CommunicationForm from "./3_CommunicationForm";
import RecordList from "./form/record";

const arr = ["논문 정보", "저자 정보", "확장 정보", "메타 정보"];//, "소통", "변경 이력"];
// , "변경 이력"
const arr2 = ["논문 정보"];
const vObj = {
  0 : <DefaultForm />,
  1 : <AuthorForm />,
  2 : <ExtendForm />,
  3 : <MetaForm />,
  // 3 : <CommunicationForm />,
  // 4 : <RecordList />,
}

class Rcontent extends Component {
	constructor(props) {
		super(props);

		const activeTabID = getParams('tab_id') ? getParams('tab_id') : 0;

		this.state = {
			activeTab: activeTabID === null ? 0 : activeTabID,
			isInit: false
		};

		this.showHide = this.showHide.bind(this)
	}

	componentDidMount() {
		let tempRecord = {
			'resource_title': "",
			'resource_title_translation': "",
			'journal_title': "",
			'issue': "",
			'registered_db': "",
			'journal_category': "",
			'publish_year': "",
			'volume': "",
			'start_page': "",
			'end_page': "",
			'total_page': "",
			'indicator_year': "",
			'input_date': ""
		}

		if (!func.getParams("record_id")) {
			this.props.dataActions.setResource({"record": tempRecord});

			if (!this.state.isInit) {
				this.setState({
					isInit: true,
				})
			}
		} else if (func.getParams("record_id")) {
			func.getData("admin/resource/" + func.getParams("record_id"), null).then((response) => {

				if (response) {
					this.props.dataActions.setResource(response)
				}

				if (!this.state.isInit) {
					this.setState({
						isInit: true,
					})
				}
			});
		} else if (!this.state.isInit) {
			this.setState({
				isInit: true,
			})
		}
	}

	showHide () {
		let status = this.props.showSide === 'true' ? 'false' : 'true'
		func.setCookie('side', status, 999)
		this.props.dataActions.setResource({'showSide' : status});
	}

	updateValue = (id) => {
		this.setState({
			activeTab: id
		});

		const url = func.changeParamUrl('tab_id', id)

		pushUrl('탭', url, null);
	}

	render() {
		return (
			<div className="col pl-0 detail journal-detail">
				{this.state.isInit &&
				<>
					<div className="detail-tabs">
						<TopNav
							tabList={this.props.record.resource_id ? arr : arr2}
							changeTab={this.updateValue}
							activeID={this.state.activeTab}
						/>
						{this.props.showSide !== 'false' &&
						<span className="hide-side-list full-screen-icon" onClick={this.showHide}/>
						}
						{this.props.showSide === 'false' &&
						<span className="view-side-list list-icon" onClick={this.showHide}/>
						}
					</div>
					<div className="detail-content">
						{vObj[this.state.activeTab]}
					</div>
				</>
				}
			</div>
		)
	}
}

export default connect(
	(state) => ({
		record: state.resources.record ? state.resources.record : {},
		showSide : state.resources.showSide ? state.resources.showSide  : 'true'
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch),
	}),
)(Rcontent)